export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-safety-cone-ced1158b35735d829e4c8452616c0105.svg";